import React from 'react';
import history from '../../../utils/history';
import { connect } from 'react-redux';
import * as actions from "../../../store/actions";
import { toQueryString } from "../../../utils/uriHelper";

import {
    EstateSearchOverlay,
    EstateSearchFilter,
    EstateSearchResults,
    EstateSearchFilterOnText,
} from '/components/estate-search/components';

import {
    CopyService,
} from '/services';

import { async } from 'regenerator-runtime';

class InternalEstateSearch extends React.Component {
    setFilterInputValue = async (name, value) => {
        let filterValues = {
            categories: [...this.props.filterValues.categories],
            locations: [...this.props.filterValues.locations],
            priceClasses: [...this.props.filterValues.priceClasses],
            minPrice: this.props.filterValues.minPrice,
            maxPrice: this.props.filterValues.maxPrice,
            groups: [...this.props.filterValues.groups],
            surfaceMin: this.props.filterValues.surfaceMin,
            surfaceMax: this.props.filterValues.surfaceMax,
        };

        filterValues[name] = value;
        this.redirect(filterValues);
    };

    setFilterValue = async (name, value) => {
        let filterValues = {
            categories: [...this.props.filterValues.categories],
            locations: [...this.props.filterValues.locations],
            priceClasses: [...this.props.filterValues.priceClasses],
            minPrice: this.props.filterValues.minPrice,
            maxPrice: this.props.filterValues.maxPrice,
            groups: [...this.props.filterValues.groups],
            surfaceMin: this.props.filterValues.surfaceMin,
            surfaceMax: this.props.filterValues.surfaceMax,
        };

        if (name === 'minPrice' || name === 'maxPrice') {
            filterValues[name] = value;
        } else {
            if (!this.props.filterValues[name].includes(value)) {
                filterValues[name] = filterValues[name].concat(value);
            } else {
                filterValues[name] = filterValues[name].filter( item => `${item}` !== `${value}` );
            }
        }

        this.redirect(filterValues);
    };

    redirect = filterValues => {
        history.push(`${history.location.pathname}${toQueryString(filterValues)}`);
    };

    componentDidMount = () => {
        this.props.requestData();
    };

    search = event => {
        event.preventDefault();
        const query = this.props.searchTerm;

        if (query.length > 0)
            this.props.search(query);
    };

    clearFilter = () => {
        history.push(history.location.pathname);
        this.resetSearch();

        this.refs.minPrice.value = "";
        this.refs.maxPrice.value = "";
    };

    handleUpdate = event => {
        this.props.setSearchTerm(event.target.value);
    };

    resetSearch = () => {
        this.props.resetSearch();
    };

    render = () => {
        if (!this.props.loaded) {
            return <h1 style={{ textAlign: "center" }}>{CopyService.get('estateSearch.loading')}</h1>
        } else {
            return (
                <div className="estate-search">
                    { this.props.searchLoading && <EstateSearchOverlay /> }
                    <div className="estate-search__header">
                        <div className="estate-search__search">
                            <div className="ais-searchBox">
                            <form noValidate="" className="ais-SearchBox-form" action="" onSubmit={ event => this.search(event) } role="search">
                                <div className="ais-SearchBox__container">
                                    <input
                                        type="search"
                                        placeholder={window.estateOverview.copy.searchField}
                                        autoComplete="off"
                                        autoCorrect="off"
                                        autoCapitalize="off"
                                        spellCheck="false"
                                        required=""
                                        maxLength="512"
                                        className="ais-SearchBox-input"
                                        onChange={ event => this.handleUpdate(event) }
                                        value={ this.props.searchTerm }
                                    />
                                    <button
                                        className="ais-SearchBox-submit button is-orange font-supplementary--bold"
                                        type="submit"
                                        title="Zoeken"
                                    >
                                        {CopyService.get('estateSearch.search')}
                                    </button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                    <div className="estate-search__filters">

                        {window.estateOverview.filters.showTransaction &&
                            <EstateSearchFilter
                                label={window.estateOverview.copy.groups.label}
                                singular={window.estateOverview.copy.groups.singular}
                                plural={window.estateOverview.copy.groups.plural}
                                attribute="groups"
                                clickHandler={this.setFilterValue}
                            />
                        }

                        <EstateSearchFilter
                            label={window.estateOverview.copy.categories.label}
                            singular={window.estateOverview.copy.categories.singular}
                            plural={window.estateOverview.copy.categories.plural}
                            attribute="categories"
                            clickHandler={this.setFilterValue}
                        />
                        <EstateSearchFilter
                            label={window.estateOverview.copy.locations.label}
                            singular={window.estateOverview.copy.locations.singular}
                            plural={window.estateOverview.copy.locations.plural}
                            attribute="locations"
                            clickHandler={this.setFilterValue}
                        />

                        {!window.estateOverview.filters.showResidential &&
                            <EstateSearchFilterOnText
                                labelMin={window.estateOverview.copy.surfaceMin.label}
                                labelMax={window.estateOverview.copy.surfaceMax.label}
                                attributeMin="surfaceMin"
                                attributeMax="surfaceMax"
                                inputHandler={this.setFilterInputValue}
                            />
                        }

                        <EstateSearchFilterOnText
                            labelMin={window.estateOverview.copy.priceMin.label}
                            labelMax={window.estateOverview.copy.priceMax.label}
                            attributeMin="minPrice"
                            attributeMax="maxPrice"
                            inputHandler={this.setFilterInputValue}
                        />
                    </div>
                    <div className="estate-search__empty-filters">
                        <button
                            className="estate-search__empty-filters__button"
                            onClick={() => this.clearFilter()}
                        >
                            {CopyService.get('estateSearch.emptyFilter')}
                        </button>
                    </div>
                    <EstateSearchResults />
                </div>
            );
        }
    };
}

const mapStateToProps = state => {
    return {
        loaded: state.categories.loaded,
        searchLoading: state.filterValues.loading,
        filterValues: state.filterValues,
        searchTerm: state.filterValues.searchTerm
    };
};

const mapDispatchToProps = dispatch => {
    return {
        requestData: () => dispatch(actions.requestData()),
        search: term => dispatch(actions.search(term)),
        resetSearch: () => dispatch(actions.resetSearch()),
        setSearchTerm: searchTerm => dispatch(actions.setSearchTerm(searchTerm))
    };
}

const EstateSearch = connect(mapStateToProps, mapDispatchToProps)(InternalEstateSearch);

export { EstateSearch };
